import { Image } from "primereact/image";

import { labelNoSourceFound } from "_constants";
import notFoundProject from "../../../../../assets/images/element_not_found.svg";

export const EmptySourcesList = () => {
  return (
    <div className="width-100 height-100 flex-container column align-center justify-center">
      <Image src={notFoundProject} alt={labelNoSourceFound} />
      <p className="empty-cards light-grey">{labelNoSourceFound}</p>
    </div>
  );
};
